/**
 * Provider para que provê um decorator para transformação de promises $http de modo a retornar diretamente
 * o response.data em vez do retorno completo da requisição.
 * 
 * @author Tomás Godoi
 * @since 1.0.0
 * 
 */
namespace app.support {

    /** @ngInject */
    function httpPromiseTransformationDecorator($delegate, $injector) {
        function decorate($injector, obj, func) {
            return angular.extend(function() {
                let httpPromiseTransformation: HttpPromiseTransformationService = $injector.get('httpPromiseTransformation');
                return httpPromiseTransformation.call(func, obj, arguments);
            }, func);
        }

        for (let prop in $delegate) {
            if (angular.isFunction($delegate[prop])) {
                $delegate[prop] = decorate($injector, $delegate, $delegate[prop]);
            }
        }
        return $delegate;
    }

    export class HttpPromiseTransformationService {

        /** @ngInject */
        constructor(private $q: ng.IQService) {

        }

        public call(func: Function, self, args) {
            let result = func.apply(self, args);
            
            if (this.isPromise(result)) {
                return result.then((response) => {
                    return this.getResponseData(response);
                }, (response) => {
                    return this.$q.reject(this.getResponseData(response));
                });
            }

            return result;
        }
        
        private getResponseData(response): any {
            if (response) {
                return response.hasOwnProperty("headers") ? response.data : response;
            }
            return response;
        }

        private isPromise(possiblePromise): boolean {
            if (possiblePromise && angular.isFunction(possiblePromise.then) && angular.isFunction(possiblePromise['catch'])) {
                return true;
            } else {
                return false;
            }
        }

    }

    export class HttpPromiseTransformationProvider implements ng.IServiceProvider {

        public decorate($provide: ng.auto.IProvideService, serviceName: string): void {
            $provide.decorator(serviceName, httpPromiseTransformationDecorator);
        }

        /** @ngInject */
        public $get($q: ng.IQService): HttpPromiseTransformationService {
            return new HttpPromiseTransformationService($q);
        }

    }

    angular
        .module('app.support')
        .provider('httpPromiseTransformation', HttpPromiseTransformationProvider);

}